module.exports = __webpack_public_path__ + "img/logo.b0d4f031.png";